import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../FirebaseConfig";
import { useFetchUserData } from "../../hooks/user/useFetchUserData";
import { Link, useNavigate } from "react-router-dom";
import FeedReaction3 from "../../NewsFeed/FeedReaction3";
import AddToFavorites from "../../UserProfile/ProfileShoppingList/AddToFavorites";
import { UserAuth } from "../../Context";

function ShoppingListPostCard2({ post }) {
  const [postData, setPostData] = useState(null);
  const { userData } = useFetchUserData(post?.userId);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [commentCount, setCommentCount] = useState(0);
  const { user } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchShoppingListPostData = async () => {
    if (!post?.id) {
      console.error("Post ID is required to fetch post data.");
      return;
    }

    try {
      // const postDocRef = doc(db, "posts", post?.id);
      // const postDocSnap = await getDoc(postDocRef);

      // const data = { id: postDocSnap.id, ...postDocSnap.data() };

      // Fetch media subcollection
      const productRef = collection(db, "posts", post?.id, "media");
      const productSnap = await getDocs(productRef);
      const products = productSnap.docs.map((doc) => ({
        id: doc.id,
        url: doc.data().url,
      }));
      const commentsCollectionRef = collection(
        db,
        "posts",
        post?.id,
        "comments"
      );

      const commentsSnapshot = await getDocs(commentsCollectionRef);
      const commentCount = commentsSnapshot?.size;
      const finalPostData = { ...post, products, commentCount };
      console.log("post", finalPostData);
      setPostData(finalPostData);
    } catch (error) {
      console.error("Error fetching post data:", error);
    }
  };

  useEffect(() => {
    fetchShoppingListPostData();
  }, [post?.id]);

  if (!postData) {
    return null;
  }

  return (
    <div
      style={{
        padding: isSmallScreen ? "6px 1.5px" : "8px 4px",
      }}
    >
      <div
        onClick={() => {
          navigate(`/postedlist/${post.id}`);
        }}
        className="d-flex flex-column border"
        style={{
          padding: "6px 6px 4px 6px",
          borderRadius: "8px",
          gap: "12px",
          cursor: "pointer",
        }}
      >
        <div
          className="d-flex align-items-center"
          style={{ gap: "1px", position: "relative" }}
        >
          <div>
            <img
              src={postData?.products[0]?.url}
              style={{
                // height: `${randomNumberInRange(280, 200)}px`,
                objectFit: "cover",
                height: "280px",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
                objectPosition: "top",
              }}
            />
          </div>
          <div style={{ position: "relative" }}>
            <img
              src={postData?.products[1]?.url}
              style={{
                // height: `${randomNumberInRange(280, 200)}px`,
                objectFit: "cover",
                height: "280px",
                // height: "16rem",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
                objectPosition: "top",
              }}
            />
            {/* <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgb(0, 0, 0, 0.4)",
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "15px",
                  letterSpacing: "0%",
                  color: "white",
                }}
              >
                View all
              </div>
            </div> */}
          </div>
          {user?.uid !== postData?.userId && (
            <div
              style={{
                position: "absolute",
                bottom: "3px",
                right: "3px",
                zIndex: 1,
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "2px",
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <AddToFavorites
                userId={user?.uid}
                list={postData}
                listName={postData?.listName}
                listId={postData?.listId}
                type={"postedShoppingList"}
              />
            </div>
          )}
        </div>
        <div className="d-flex align-items-center" style={{ gap: "14px" }}>
          <div>
            <img
              src={
                userData?.photo ||
                `https://ui-avatars.com/api/?name=${userData?.userName}`
              }
              style={{
                height: "50px",
                width: "50px",
                borderRadius: "8px",
              }}
              alt=""
            />
          </div>
          <div className="d-flex flex-column" style={{ gap: "4px" }}>
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "#667085",
              }}
            >
              Posted By
            </div>
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "black",
              }}
            >
              {userData.userName
                ? userData.userName
                    .split(" ")
                    .slice(0, 2)
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")
                : ""}
            </div>
          </div>
        </div>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "18px",
            letterSpacing: "0%",
            color: "black",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            "-webkit-line-clamp": "2",
            "-webkit-box-orient": "vertical",
          }}
        >
          {post?.title}
        </div>
        {/* <PostReaction post={postData} /> */}
        <div>
          <FeedReaction3
            post={postData}
            commentCount={commentCount}
            setCommentCount={setCommentCount}
            componentName={"ShoppingListPostCard"}
          />
        </div>
      </div>
    </div>
  );
}

export default ShoppingListPostCard2;
